// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a0-0";
export var orangeButton = "_a0-1";